var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-contain"},[_c('div',{staticClass:"module-title main-title-text"},[_vm._v("实时运行参数")]),_c('div',{staticClass:"table-box"},[_c('dv-scroll-board',{staticClass:"table",attrs:{"config":_vm.config}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }